// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B27wN5INCjrQTV {
  display: flex;
  z-index: 1;
  flex: 1 1 auto;
  flex-direction: column;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
  padding: var(--ds-space-050, 4px);
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
  row-gap: 8px;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translate3d(0, 0, 0);
  scrollbar-color: var(--ds-background-neutral-hovered, #091e4224) var(--ds-background-neutral, #091e420f);
  scrollbar-width: thin;
}
.B27wN5INCjrQTV.LcFnJFfQdwDOsP {
  row-gap: var(--ds-space-0, 0);
  margin-top: var(--ds-space-negative-050, -4px);
}
[data-drag-preview] .B27wN5INCjrQTV {
  /* stylelint-disable-next-line declaration-no-important */
  overflow-y: hidden !important;
}
.B27wN5INCjrQTV[hidden] {
  display: none;
}
.B27wN5INCjrQTV::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.B27wN5INCjrQTV::-webkit-scrollbar-button:start:decrement,
.B27wN5INCjrQTV::-webkit-scrollbar-button:end:increment {
  display: none;
  background: transparent;
}
.B27wN5INCjrQTV::-webkit-scrollbar-track-piece {
  background: var(--ds-background-neutral, #091e420f);
}
.B27wN5INCjrQTV::-webkit-scrollbar-track-piece:vertical:start {
  border-radius: var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px) 0 0;
}
.B27wN5INCjrQTV::-webkit-scrollbar-track-piece:vertical:end {
  border-radius: 0 0 var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px);
}
.B27wN5INCjrQTV::-webkit-scrollbar-track-piece:horizontal:start {
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
}
.B27wN5INCjrQTV::-webkit-scrollbar-track-piece:horizontal:end {
  border-radius: 0 var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px) 0;
}
.B27wN5INCjrQTV::-webkit-scrollbar-thumb:vertical,
.B27wN5INCjrQTV::-webkit-scrollbar-thumb:horizontal {
  display: block;
  height: 48px;
  border-radius: var(--ds-border-radius-100, 4px);
  background: var(--ds-background-neutral-hovered, #091e4224);
}
.B27wN5INCjrQTV::-webkit-scrollbar-button:end {
  display: block;
  width: 4px;
  height: 4px;
}
@-moz-document url-prefix() {
  .B27wN5INCjrQTV {
    margin-right: var(--ds-space-0, 0);
    padding-right: var(--ds-space-100, 8px);
  }
}
.WkETrogJNnWdl3 {
  display: none;
  flex-shrink: 0;
  height: 8px;
  margin-bottom: var(--ds-space-negative-050, -4px);
}
.WkETrogJNnWdl3[hidden] {
  /* stylelint-disable-next-line declaration-no-important */
  display: none !important;
}
@supports (selector(:has(*))) {
  .WkETrogJNnWdl3:has( + .B27wN5INCjrQTV > *:not([hidden])) {
    display: block;
  }
}
@supports not (selector(:has(*))) {
  .WkETrogJNnWdl3 {
    display: block;
  }
}
.YgMR5lMsUO1fu3 {
  margin-top: 8px;
}
`, ""]);
// Exports
export var listCards = `B27wN5INCjrQTV`;
export var hoverGapEnabled = `LcFnJFfQdwDOsP`;
export var topBuffer = `WkETrogJNnWdl3`;
export var lastDropPreview = `YgMR5lMsUO1fu3`;
export default ___CSS_LOADER_EXPORT___;
